/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export const typographyUnits = {
    webXs: '11px',
    webSm: '12px',
    webMd: '14px',
    webLg: '16px',
    webXl: '20px',
    web2Xl: '24px',
    web3Xl: '32px',
    web4Xl: '40px',
    web5Xl: '48px',
    web6Xl: '56px',
    web7Xl: '64px'
}

export const typographyStyle = {
    webH1: {
        fontSize: {base: typographyUnits.webXl, lg: typographyUnits.web2Xl},
        lineHeight: {base: '24px', lg: '30px'},
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: 'webTypo.textPrimary'
    },
    webH2: {
        fontSize: {base: typographyUnits.webLg, lg: typographyUnits.webXl},
        lineHeight: {base: '20px', lg: '24px'},
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: 'webTypo.textPrimary'
    },
    webH3: {
        fontSize: {base: typographyUnits.webMd, lg: typographyUnits.webLg},
        lineHeight: {base: '20px', lg: '20px'},
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: 'webTypo.textPrimary'
    },
    webH4: {
        fontSize: {base: typographyUnits.webSm, lg: typographyUnits.webMd},
        lineHeight: {base: '16px', lg: '20px'},
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: 'webTypo.textPrimary'
    },
    bodyLgRegular: {
        fontSize: typographyUnits.webXl,
        lineHeight: '24px',
        fontWeight: 'normal',
        color: 'webTypo.textPrimary'
    },
    bodyLgMedium: {
        fontSize: typographyUnits.webXl,
        lineHeight: '24px',
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    bodyMdRegular: {
        fontSize: typographyUnits.webLg,
        lineHeight: '20px',
        fontWeight: 'normal',
        color: 'webTypo.textPrimary'
    },
    bodyMdLink: {
        fontSize: typographyUnits.webLg,
        lineHeight: '20px',
        fontWeight: 'normal',
        textDecoration: 'underline',
        color: 'webTypo.textPrimary'
    },
    bodyMdMedium: {
        fontSize: typographyUnits.webLg,
        lineHeight: '20px',
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    bodyMdBold: {
        fontSize: typographyUnits.webLg,
        lineHeight: '20px',
        fontWeight: 'bold',
        color: 'webTypo.textPrimary'
    },
    bodySmRegular: {
        fontSize: typographyUnits.webMd,
        lineHeight: '20px',
        fontWeight: 'normal',
        color: 'webTypo.textPrimary'
    },
    bodySmLink: {
        fontSize: typographyUnits.webMd,
        lineHeight: '20px',
        fontWeight: 'normal',
        textDecoration: 'underline',
        color: 'webTypo.textPrimary'
    },
    bodySmMedium: {
        fontSize: typographyUnits.webMd,
        lineHeight: '20px',
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    bodySmBold: {
        fontSize: typographyUnits.webMd,
        lineHeight: '20px',
        fontWeight: 'bold',
        color: 'webTypo.textPrimary'
    },
    bodyXsRegular: {
        fontSize: typographyUnits.webSm,
        lineHeight: '16px',
        fontWeight: 'normal',
        color: 'webTypo.textPrimary'
    },
    bodyXsLink: {
        fontSize: typographyUnits.webSm,
        lineHeight: '16px',
        fontWeight: 'normal',
        textDecoration: 'underline',
        color: 'webTypo.textPrimary'
    },
    bodyXsBold: {
        fontSize: typographyUnits.webSm,
        lineHeight: '16px',
        fontWeight: 'bold',
        color: 'webTypo.textPrimary'
    },
    bodyXsMedium: {
        fontSize: typographyUnits.webSm,
        lineHeight: '16px',
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    bodyXsSRegular: {
        fontSize: {base: typographyUnits.webSm, md: typographyUnits.webMd, lg: typographyUnits.webMd},
        lineHeight: {base: '16px', md: '20px', lg: '20px'},
        fontWeight: 'normal',
        color: 'webTypo.textPrimary'
    },
    bodyXsSBold: {
        fontSize: {base: typographyUnits.webSm, md: typographyUnits.webMd, lg: typographyUnits.webMd},
        lineHeight: {base: '16px', md: '20px', lg: '20px'},
        fontWeight: 'bold',
        color: 'webTypo.textPrimary'
    },
    bodyXsSLink: {
        fontSize: {base: typographyUnits.webSm, md: typographyUnits.webMd, lg: typographyUnits.webMd},
        lineHeight: {base: '16px', md: '20px', lg: '20px'},
        fontWeight: 'normal',
        textDecoration: 'underline',
        color: 'webTypo.textPrimary'
    },
    bodyXsSMedium: {
        fontSize: {base: typographyUnits.webSm, md: typographyUnits.webMd, lg: typographyUnits.webMd},
        lineHeight: {base: '16px', md: '20px', lg: '20px'},
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    cta: {
        fontSize: typographyUnits.webMd,
        lineHeight: '20px',
        fontWeight: 'bold',
        color: 'webTypo.textPrimary'
    },
    ctaUnderlined: {
        fontSize: typographyUnits.webMd,
        lineHeight: '20px',
        fontWeight: 'bold',
        textDecoration: 'underline',
        color: 'webTypo.textPrimary'
    },
    ctaOther: {
        fontSize: typographyUnits.webMd,
        lineHeight: '20px',
        fontWeight: 'bold',
        textTransform: 'uppercase'
    },
    largeTitle1: {
        fontSize: {base: typographyUnits.web4Xl, md: typographyUnits.web4Xl, lg: typographyUnits.web7Xl},
        lineHeight: {base: '48px', md: '48px', lg: '64px'},
        fontWeight: 'normal',
        color: 'webTypo.textPrimary'
    },
    largeTitle2: {
        fontSize: typographyUnits.web3Xl,
        lineHeight: '40px',
        fontWeight: 'normal',
        color: 'webTypo.textPrimary'
    },
    badge: {
        fontSize: {base: typographyUnits.webXs, md: typographyUnits.webSm, lg: typographyUnits.webSm},
        lineHeight: {base: '12px', md: '12px', lg: '12px'},
        fontWeight: 'medium',
        textTransform: 'uppercase',
        color: 'webTypo.textPrimary'
    },
    labelXs: {
        fontSize: {base: typographyUnits.webSm, md: typographyUnits.webMd, lg: typographyUnits.webMd},
        lineHeight: {base: '16px', md: '20px', lg: '20px'},
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    labelSm: {
        fontSize: {base: typographyUnits.webMd, md: typographyUnits.webMd, lg: typographyUnits.webMd},
        lineHeight: {base: '20px', md: '20px', lg: '20px'},
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    labelSmMd: {
        fontSize: {base: typographyUnits.webMd, md: typographyUnits.webMd, lg: typographyUnits.webLg},
        lineHeight: {base: '20px', md: '20px', lg: '20px'},
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    labelMdSm: {
        fontSize: {base: typographyUnits.webLg, md: typographyUnits.webLg, lg: typographyUnits.webMd},
        lineHeight: {base: '20px', md: '20px', lg: '20px'},
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    subtitle: {
        fontSize: typographyUnits.webSm,
        lineHeight: '16px',
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    footer: {
        fontSize: {base: typographyUnits.webLg, md: typographyUnits.webLg, lg: typographyUnits.webSm},
        lineHeight: {base: '20px', md: '20px', lg: '16px'},
        fontWeight: 'medium',
        color: 'webTypo.textPrimary'
    },
    webButtonTypography: {
        fontSize: {base: typographyUnits.webMd},
        lineHeight: {base: '20px'},
        fontWeight: 'bold',
        textTransform: 'uppercase'
    }
}
